/**
 * The leaflet cart — what a visitor has picked on the choose-leaflets page.
 *
 * Kept in localStorage so the picks survive a refresh, a detour to another
 * page, or coming back later, without needing an account. It is only a
 * convenience copy: checkout re-sends the ids and the server re-checks every
 * one of them and the price, so nothing here is trusted.
 */
export interface LeafletCart {
  planId: string;
  courseIds: string[];
  /** Subset of `courseIds` bought with the companion video. */
  videoCourseIds: string[];
}

const CART_KEY = "leaflet_cart";

const isStringArray = (v: unknown): v is string[] =>
  Array.isArray(v) && v.every((x) => typeof x === "string");

export const loadLeafletCart = (): LeafletCart | null => {
  try {
    const raw = JSON.parse(localStorage.getItem(CART_KEY) || "null");
    if (!raw || typeof raw.planId !== "string" || !isStringArray(raw.courseIds) || !isStringArray(raw.videoCourseIds)) {
      return null;
    }
    return { planId: raw.planId, courseIds: raw.courseIds, videoCourseIds: raw.videoCourseIds };
  } catch {
    return null;
  }
};

export const saveLeafletCart = (cart: LeafletCart): void => {
  try {
    if (cart.courseIds.length === 0) localStorage.removeItem(CART_KEY);
    else localStorage.setItem(CART_KEY, JSON.stringify(cart));
  } catch {
    // Storage full or blocked (private mode) — the cart just won't persist.
  }
};

export const clearLeafletCart = (): void => {
  try { localStorage.removeItem(CART_KEY); } catch { /* nothing to clear */ }
};
